// CookieUtils.js
export function setSharedCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    // L'attribut Domain est la clé ! Il doit commencer par un point.
    // Secure est obligatoire pour SameSite=None
    let domain = getTopDomain(window.location.hostname);
    document.cookie = `${name}=${value || ""}${expires}; path=/; Domain=.${domain}; Secure; SameSite=Lax`;
    console.log(document.cookie);
}

export function getSharedCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export function getTopDomain(url) {
    // Remove the protocol part (e.g., http://, https://)
    const protocolRegex = /^https?:\/\//i;
    let domain = url.replace(protocolRegex, '');

    // Remove the www. part if it exists
    const wwwRegex = /^www\./i;
    domain = domain.replace(wwwRegex, '');

    // Split the domain by dots
    const parts = domain.split('.');

    // Check if the domain has at least two parts (e.g., example.com)
    if (parts.length >= 2) {
        // The top-level domain is the last part
        return parts[parts.length - 2] + "." + parts[parts.length - 1];
    } else {
        // If the domain is invalid, return null or an appropriate message
        return null;
    }
}